import React from 'react';
import { useProCalculator } from '../hooks/useProCalculator';
import SectionHelp from './SectionHelp';
import '../styles/OrdersSection.css';

const OrdersSection = () => {
  const {
    orderRows,
    updateOrderRow,
    cookieRows,
    useSets,
    setRows,
    setSetRows, // The setter function for sets
    isMobile,
    goToNextSection,
    activeSection,
    setActiveSection
  } = useProCalculator();

  return (
    <div className="orders-section">
      <div className="section-header">
        <h2 className="section-title">Orders</h2>
      </div>
      {/* Help text container */}
      <div className="section-help-container">
        <SectionHelp sectionId="orders" isMobile={isMobile} />
      </div>
      
      {useSets ? (
        <div className="sets-orders-table">
          <div className="sets-orders-header">
            <div className="set-name-header">Set Name</div>
            <div className="count-header">Count per Order</div>
          </div>
          
          {(() => {
            // Get unique set names
            const uniqueSets = [];
            const setNames = new Set();
            
            setRows.forEach(row => {
              if (row.setName && row.cookieId && !setNames.has(row.setName)) {
                setNames.add(row.setName);
                uniqueSets.push(row);
              }
            });
            
            return uniqueSets.map(row => (
              <div key={row.id} className="set-row">
                <div className="set-name-field">
                  {row.setName || 'Unnamed Set'}
                </div>
                <div className="count-field">
                  <input
                    type="number"
                    min="0"
                    max="999"
                    value={row.count || 0}
                    onChange={(e) => {
                      const value = Math.min(999, Math.max(0, parseInt(e.target.value) || 0));
                      
                      // Update count for all rows with this set name
                      const updatedRows = setRows.map(r => 
                        r.setName === row.setName ? { ...r, count: value } : r
                      );
                      setSetRows(updatedRows); // Use the correct setter function
                    }}
                    className="count-input"
                  />
                </div>
              </div>
            ));
          })()}
        </div>
      ) : (
        <div className="cookies-orders-table">
          <div className="cookies-orders-header">
            <div className="cookie-name-header">Cookie Name</div>
            <div className="count-header">Count per Order</div>
          </div>
          
          {cookieRows.map(cookie => {
            // Find the corresponding order row
            const orderRow = orderRows.find(o => o.cookieId === cookie.id) || { count: 0 };
            
            return (
              <div key={cookie.id} className="cookie-order-row">
                <div className="cookie-name-field">
                  {cookie.cookieName || 'Unnamed Cookie'}
                </div>
                <div className="count-field">
                  <input
                    type="number"
                    min="0"
                    max="999"
                    value={orderRow.count || 0}
                    onChange={(e) => {
                      const value = Math.min(999, Math.max(0, parseInt(e.target.value) || 0));
                      
                      // updateOrderRow logic expects cookieId and the new count value
                      updateOrderRow(cookie.id, value); 
                    }}
                    className="count-input"
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
      
      {/* Next section button container */}
      {activeSection !== 'all' && (
        <div className="next-button-container">
          <button
            className="next-section-button"
            onClick={() => setActiveSection('results')}
          >
            Next: Results
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default OrdersSection;
